import { AfterViewInit, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Component } from '@angular/core';
import { MatChipOption } from '@angular/material/chips';
import * as feather from 'feather-icons';
import { Dictionary } from 'lodash';
import { Constants } from 'src/app/common/constants/constants';
import { Competency } from 'src/app/common/models/competency';
import { CompetencyTemplate } from 'src/app/common/models/competencyTemplate';
import { CompetencyTemplateService } from 'src/app/common/services/competency-type.service';
import { CompetencyService } from 'src/app/common/services/competency.service';

@Component({
    selector: 'app-self-assessment',
    templateUrl: './self-assessment.component.html',
    styleUrls: ['./self-assessment.component.css'],
    standalone: false
})

export class SelfAssessmentComponent implements OnInit, AfterViewInit {

  @Input() competencies: Competency[]
  @Output() competencyChange = new EventEmitter();
  @Output() toggleButton = new EventEmitter();

  showError = false;
  buttonDisabled = false;

  constructor(private CompetencyTemplateService: CompetencyTemplateService, private competencyService: CompetencyService) { }
  groupedCompetencies: Dictionary<CompetencyTemplate[]>;


  ngOnInit(): void {
    this.CompetencyTemplateService.getCompetencyTemplatesGrouped()
      .subscribe(data => this.groupedCompetencies = data);
  }

  ngAfterViewInit() {
    feather.replace();
  }

  getCompetencyDescription(domain: string, name: string): string {
     if(domain === "Other"){
      return Constants.otherCompetencyDescription
     }
    const list = this.groupedCompetencies[domain];
    const result = list?.find(r => r.Name == name);
    return result?.Description;
  }

  clickSelection(chip: MatChipOption, competency: Competency) {
    if(!chip.selected) {
      const result = this.competencies.find(r => r.Id === competency.Id);
      result.Rating = chip.value;
      chip.toggleSelected();
      this.toggleButton.emit(true);
      this.competencyService.updateCompetencyRating(result).subscribe(()=>{
        this.toggleButton.emit(false);
      });
    }
  }

  keyboardSelection($event: Event, chip: MatChipOption, competency: Competency) {
    if(!chip.selected) {
      $event.stopImmediatePropagation();
      const result = this.competencies.find(r => r.Id === competency.Id);
      result.Rating = chip.value;
      chip.toggleSelected();
      this.toggleButton.emit(true);
      this.competencyService.updateCompetencyRating(result).subscribe(()=>{
        this.toggleButton.emit(false);
      });
    }
  }

  isSelected(chip: MatChipOption, competency: Competency) {
    return chip.value === competency.Rating;
  }

  validateForm(): boolean {
    if(this.competencies.filter(r=>r.Rating === null).length > 0) {
      this.showError = true;
      document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
      return false;
    }
    else {
      return true;
    }
  }

  isValid(): boolean {
    if(this.competencies?.filter(r=>r.Rating === null).length > 0) {
      return false;
    }
    else {
      return true;
    }
  }

}
